export default __webpack_public_path__ + "assets/images/dc9df444c608a60f7818daf2831e584d.png";